import { Client } from "./client";

export class ClientSendResource {
        clienteDto: Client;
        idAdministradora: number;
}